import RefappAmp from './directives/RefappAmp';

export default {
  install(app) {
    app.directive('refapp-amp', RefappAmp);
  },
};
